import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { customerProductStatus } from 'global/Models/branchCustomerProductTypeModel';

type initialStateType = {
  customerProductStatus: customerProductStatus[] | undefined;
};

const initialState: initialStateType = { customerProductStatus: undefined };

const customerBranchProductSlice = createSlice({
  name: 'customerBranchProduct',
  initialState,
  reducers: {
    setCustomerBranchProduct: (state, { payload }: PayloadAction<customerProductStatus[]>) => {
      state.customerProductStatus = payload;
    },
  },
});

export const { setCustomerBranchProduct } = customerBranchProductSlice.actions;
export default customerBranchProductSlice.reducer;
